import Buy from "."; 

export const buyRoutes = () => [
  {
    path: "/buy",
    component: Buy,
    layout: "front",
    title: "page",
  },
];